import React from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ResultDetailBox = (header, body) => {
  return (
    <Box
      borderRadius="5px"
      boxShadow="0 2px 5px 0 rgba(189,189,189,0.26), 0 2px 10px 0 rgba(65,65,65,0.16)"
      mt="32px"
    >
      <Box
        bgcolor="#009688"
        p="16px"
        style={{
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
        }}
      >
        <Typography variant="h6" style={{ color: 'white' }}>
          {header}
        </Typography>
      </Box>
      <Box py="16px" px="16px" maxWidth="700px">
        {body}
      </Box>
    </Box>
  );
};

export const EmergencyHelp = () => {
  const theme = useTheme();
  const isSmallScreen = !useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box
      boxShadow="0 2px 5px 0 rgba(189,189,189,0.26), 0 2px 10px 0
      rgba(65,65,65,0.16)"
      mt="40px"
      p={4}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        display="flex"
        py={2}
        alignItems="center"
        alignContent="center"
      >
        <FontAwesomeIcon
          icon={['fas', 'exclamation-triangle']}
          style={{
            color: '#ff5349',
            fontSize: 24,
            marginRight: 16,
          }}
        />
        <Typography
          variant={isSmallScreen ? 'body2' : 'body1'}
          style={{ fontWeight: 600 }}
        >
          {
            'यदि तपाई संकटमा हुनुहुन्छ भने तत्काल सहयोगको लागि तलका टेलिफोन नम्बरहरुमा सम्पर्क गर्नुहोस्'
          }
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems={isSmallScreen ? 'flex-start' : 'center'}
        justifyContent={isSmallScreen ? 'flex-start' : 'center'}
      >
        <Typography variant="body1" gutterBottom>
          {
            'पाटन अस्पताल हटलाइन (सुसाइड रोकथाम ) - २४ घण्टा : ९८१३४७६१२३'
          }
        </Typography>
        <Typography variant="body1" gutterBottom>
          {'TUTH सुसाइड हटलाइन - २४ घण्टा: ९८४००२१६००'}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {
            'टि.पि.ओ नेपाल क्राइसिस हटलाइन (बिहान ८ देखि बेलुका ७ बजे सम्म): १६६० ०१ ० २००५'
          }
        </Typography>
        <Typography variant="body1" gutterBottom>
          {
            'कोभिड १९ क्राइसिस - नि:शुल्क मनोवैज्ञानिक प्राथमिक उपचार र मनोपरामर्शको लागि कोशिश नेपालको टोल फ्री नम्बर (बिहान ८ देखि बेलुका ७ बजे सम्म): १६६००१-२२३२२'
          }
        </Typography>
      </Box>
    </Box>
  );
};

export const ResultScoreBlock = ({ score }) => (
  <Box
    borderRadius="5px"
    width="300px"
    p="16px"
    position="relative"
    boxShadow="0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)"
  >
    <Typography variant="h6" style={{ color: '#232e52' }}>
      तपाइको अंक
    </Typography>
    <Typography variant="body1">{`${score} (कम)`}</Typography>
    <Box
      width="5px"
      height="100%"
      bgcolor="#009688"
      position="absolute"
      top="0"
      left="0"
      style={{
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
      }}
    />
  </Box>
);
